
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'


export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['data'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const count = 22
        
        onBeforeUnmount(() => {
            
        })

        onMounted(() => {
            
        })    

        return {
            count
        }
    }
})
